<template>
  <div class="container">
    <div class="login-lang">
      <el-dropdown
        trigger="click"
        placement="bottom-end"
        @command="handleChangeLang"
        @visible-change="langMenuVisible = $event"
      >
        <button
          type="button"
          class="lang-trigger"
          :aria-label="$t('public.language') + ': ' + curLangLabel"
          :aria-expanded="String(langMenuVisible)"
          @keydown.enter.prevent
        >
          <svg class="lang-globe" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <ellipse cx="12" cy="12" rx="4" ry="9" />
            <path d="M3 12h18" />
          </svg>
          <span class="lang-current">{{ curLangLabel }}</span>
          <i class="el-icon-arrow-down lang-arrow" :class="{ expanded: langMenuVisible }" aria-hidden="true"></i>
        </button>
        <el-dropdown-menu slot="dropdown" class="login-lang-menu">
          <el-dropdown-item
            v-for="l in langEnum"
            :key="l.type"
            :command="l"
            class="login-lang-option"
            :class="{ active: l.type === curLang }"
          >
            <span>{{ l.label }}</span>
            <i v-if="l.type === curLang" class="el-icon-check" aria-hidden="true"></i>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="form flex">
      <div class="login">
        <div class="form-content flex-dc lg">
          <div class="login_main" v-if="login == 'login'">
            <div class="login_title ft1">{{ $t("login.title") }}</div>
            <div class="ft2">
              <span>{{ $t("login.no_account") }}</span>
              <el-button
                type="text"
                class="ft2"
                @click="loginChange('register')"
                >{{ $t("login.create_account") }}</el-button
              >
            </div>
            <div class="blue_line"></div>
            <!-- 登录表单 -->
            <el-form ref="form" :model="form" :rules="rules" :validate-on-rule-change="false">
              <el-form-item prop="username">
                <el-input v-model="form.username" :placeholder="$t('login.username_ph')">
                  <i
                    class="iconfont icon-yonghu el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="form.password"
                  :placeholder="$t('login.password_ph')"
                  show-password
                  maxlength="18"
                >
                  <i
                    class="iconfont icon-mima el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="verCode">
                <div class="flex">
                  <el-input v-model="form.verCode" :placeholder="$t('login.vercode_ph')">
                    <i
                      class="iconfont icon-mima el-input__icon icon_style"
                      slot="prefix"
                    >
                    </i>
                  </el-input>
                  <div
                    class="verCode"
                    @click="getVerCode"
                    :style="{
                      backgroundImage: `url(${codeURL})`,
                      backgroundSize: '100% 100%',
                    }"
                  ></div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="form-btn"
                  block
                  type="primary"
                  :loading="loading"
                  @click="doLogin"
                  style="width: 100%"
                  >{{ $t("login.login_btn") }}</el-button
                >
              </el-form-item>
            </el-form>
            <div class="check_pass">
              <el-checkbox v-model="rememberPwd" style="color: #999999"
                >{{ $t("login.remember_pwd") }}</el-checkbox
              >
              <el-button
                type="text"
                style="color: #999999"
                @click="loginChange('forget')"
                >{{ $t("login.forget_password") }}</el-button
              >
            </div>
          </div>
          <div class="login_main" v-else-if="login == 'register'">
            <div class="login_title ft1">{{ $t("login.register_title") }}</div>
            <div class="ft2">
              <span>{{ $t("login.has_account") }}</span>
              <!-- <span>创建账户</span> -->
              <el-button type="text" class="ft2" @click="loginChange('login')"
                >{{ $t("login.go_login") }}</el-button
              >
            </div>
            <div class="blue_line"></div>
            <!-- 创建账户-注册表单 -->
            <el-form ref="regForm" :model="regForm" :rules="rules" :validate-on-rule-change="false">
              <el-form-item prop="phone">
                <el-input v-model="regForm.phone" :placeholder="$t('login.phone_ph')">
                  <i
                    class="iconfont icon-bianzu4 el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="regVerCode">
                <el-input
                  v-model="regForm.regVerCode"
                  :placeholder="$t('login.sms_code_ph')"
                  autocomplete="off"
                  readonly
	                onfocus="this.removeAttribute('readonly');" 
                >
                  <i
                    class="iconfont icon-verify el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                  <el-button
                    v-if="!getMsgCode"
                    slot="suffix"
                    type="text"
                    size="mini"
                    style="margin: 6px 6px 0 0"
                    @click="regGetCode('reg')"
                    >{{ $t("login.get_code") }}</el-button
                  >
                  <div
                    v-else
                    slot="suffix"
                    style="margin-right: 6px; color: #3477f6"
                  >
                    {{ second + "S" }}
                  </div>
                </el-input>
              </el-form-item>
              <el-form-item prop="project">
                <el-input
                  v-model="regForm.project"
                  :placeholder="$t('login.project_ph')"
                  maxlength="50"
                >
                  <i
                    class="iconfont icon-xiangmumingcheng el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="pwd">
                <el-input
                  v-model="regForm.pwd"
                  :placeholder="$t('login.password_ph')"
                  show-password
                  maxlength="18"
                  autocomplete="new-password"
                >
                  <i
                    class="iconfont icon-mima el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="rePwd">
                <el-input
                  v-model="regForm.rePwd"
                  :placeholder="$t('login.repwd_ph')"
                  show-password
                  maxlength="18"
                  autocomplete="new-password"
                >
                  <i
                    class="iconfont icon-mima el-input__icon icon_style"
                    slot="prefix"
                  >
                  </i>
                </el-input>
              </el-form-item>
            </el-form>
            <el-button
              class="form-btn"
              block
              type="primary"
              :loading="loading"
              @click="register"
              style="width: 100%"
              >{{ $t("login.register_btn") }}</el-button
            >
          </div>
          <!-- 忘记密码-账户验证 -->
          <div class="login_main" v-else>
            <div class="login_title ft1">{{ $t("login.verify_account") }}</div>
            <el-button type="text" class="ft2" @click="forgetBack"
                >{{ $t("login.go_login") }}</el-button
              >
            <div class="blue_line"></div>
            <!--  -->
            <el-form ref="forgetForm" :model="forgetForm" :rules="rules" :validate-on-rule-change="false">
              <div v-if="checkPhone">
                <el-form-item prop="phone">
                  <el-input
                    v-model="forgetForm.phone"
                    :placeholder="$t('login.phone_ph')"
                  >
                    <i
                      class="iconfont icon-bianzu4 el-input__icon icon_style"
                      slot="prefix"
                    >
                    </i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="regVerCode">
                  <el-input
                    v-model="forgetForm.regVerCode"
                    :placeholder="$t('login.sms_code_ph')"
                    autocomplete="off"
                  >
                    <i
                      class="iconfont icon-verify el-input__icon icon_style"
                      slot="prefix"
                    >
                    </i>
                    <el-button
                      v-if="!getMsgCode"
                      slot="suffix"
                      type="text"
                      size="mini"
                      style="margin: 6px 6px 0 0"
                      @click="forgetGetCode('for')"
                      >{{ $t("login.get_code") }}</el-button
                    >
                    <div
                      v-else
                      slot="suffix"
                      style="margin-right: 6px; color: #3477f6"
                    >
                      {{ second + "S" }}
                    </div>
                  </el-input>
                </el-form-item>
              </div>
              <template v-else>
                <el-form-item prop="pwd">
                  <el-input
                    v-model="forgetForm.pwd"
                    :placeholder="$t('login.password_ph')"
                    show-password
                    maxlength="18"
                    autocomplete="new-password"
                  >
                    <i
                      class="iconfont icon-mima el-input__icon icon_style"
                      slot="prefix"
                    >
                    </i>
                  </el-input>
                </el-form-item>
                <el-form-item prop="rePwd2">
                  <el-input
                    v-model="forgetForm.rePwd2"
                    :placeholder="$t('login.repwd_ph')"
                    show-password
                    maxlength="18"
                    autocomplete="new-password"
                  >
                    <i
                      class="iconfont icon-mima el-input__icon icon_style"
                      slot="prefix"
                    >
                    </i>
                  </el-input>
                </el-form-item>
              </template>
              <el-form-item>
                <el-button
                  class="form-btn"
                  block
                  type="primary"
                  :loading="loading"
                  v-if="checkPhone"
                  @click="verPhone"
                  style="width: 100%"
                  >{{ $t("public.submit") }}</el-button
                >
                <el-button
                  class="form-btn"
                  block
                  type="primary"
                  v-else
                  :loading="loading"
                  @click="toSetPwd"
                  style="width: 100%"
                  >{{ $t("public.submit") }}</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 审核弹窗 -->
    <div>
      <custom-dialog
        :show="show"
        :title="$t('public.tip')"
        width="500"
        @toggleShow="show = false"
        :notPaddingTop="false"
      >
        <div slot="main" class="main">
          <div></div>
          <div class="content">{{ $t("login.auditing_content") }}</div>
          <div>{{ $t("login.auditing_tip") }}</div>
        </div>
        <div class="flex btns" slot="footer">
          <el-button
            type="primary"
            class="btn save"
            size="small"
            @click="show = false"
          >
            {{ $t("public.submit") }}
          </el-button>
        </div>
      </custom-dialog>
    </div>
    <!-- 短信图形验证码 -->
    <div>
      <custom-dialog
        :show="codeShow"
        :title="$t('login.vercode_ph')"
        width="400"
        @toggleShow="codeShow = false"
      >
        <div slot="main" style="display: flex; justify-content: space-around">
          <div
            class="verCode"
            :style="{
              backgroundImage: `url(${codeURL})`,
              backgroundSize: '100% 100%',
            }"
            @click="getVerCode"
          ></div>
          <div>
            <el-form
              size="small"
              :model="codeForm"
              :rules="rules"
              :validate-on-rule-change="false"
              ref="codeForm"
              style="display: flex; align-items: center"
            >
              <el-form-item label="" prop="code">
                <el-input
                  v-model="codeForm.code"
                  :placeholder="$t('login.vercode_input_ph')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="flex btns" slot="footer">
          <el-button
            type="primary"
            class="btn save"
            size="small"
            @click="setTime"
          >
            {{ $t("public.submit") }}
          </el-button>
        </div>
      </custom-dialog>
      <!-- @click="submit" -->
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { advanceSession, sessionSnapshot, isCurrentSession } from '@/utils/session';
import CustomDialog from "../../components/public/customDialog";
import { getCookie, setCookie, delCookie } from "@/utils/cookie";
import { login, getCode, getMsgCode, register, resetPwd } from "@/api/index";
import { Message, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import { langEnum } from "@/config/project";
import { setLocale, afterLogin } from "@/utils/locale";
export default {
  components: {
    CustomDialog,
    ElDropdown: Dropdown,
    ElDropdownMenu: DropdownMenu,
    ElDropdownItem: DropdownItem,
  },
  data() {
    return {
      langEnum,
      langMenuVisible: false,
      getMsgType: "",
      codeShow: false,
      codeURL: "",
      codeID: "",
      checkPhone: true,
      show: false,
      timer: null,
      second: 60,
      getMsgCode: false,
      login: "login", // register forget
      rememberPwd: false,
      activeInput: "",
      loading: false,
      regForm: {
        // 注册表单
        regVerCode: "",
        phone: "",
        project: "",
        pwd: "",
        rePwd: "",
      },
      forgetForm: {
        regVerCode: "",
        phone: "",
        pwd: "",
        rePwd2: "",
      },
      form: {
        // 登录表单
        username: "", // 账号 17884823877
        password: "", // 密码 Hwang793
        verCode: "",
      },
      codeForm: {
        code: "",
      },
      showPassword: false,
      routes: [],
    };
  },
  computed: {
    curLang() {
      return this.$i18n.locale;
    },
    curLangLabel() {
      const current = this.langEnum.find(l => l.type === this.curLang);
      return current ? current.label : this.curLang;
    },
    // rules 转 computed：校验消息随语言热切换重建
    rules() {
      const validValueNumAndLetter = (rule, value, callback) => {
        if (!value) callback(new Error(this.$t("login.pwd_empty")));
        else if (!this.$tool.regExp.validPwd(value))
          callback(new Error(this.$t("login.pwd_rule")));
        else callback();
      };
      const validVerCode = (rule, value, callback) => {
        if (!value) callback(new Error(this.$t("login.vercode_empty")));
        else callback();
      };
      const validPhone = (rule, value, callback) => {
        if (!value) callback(new Error(this.$t("login.phone_empty")));
        else if (!this.$tool.regExp.validPhone(value))
          callback(new Error(this.$t("login.phone_invalid")));
        else callback();
      };
      const validSurePwd = (rule, value, callback) => {
        if (this.regForm.rePwd !== this.regForm.pwd)
          callback(new Error(this.$t("login.pwd_mismatch")));
        else callback();
      };
      const validSurePwd2 = (rule, value, callback) => {
        if (this.forgetForm.rePwd2 !== this.forgetForm.pwd)
          callback(new Error(this.$t("login.pwd_mismatch")));
        else callback();
      };
      return {
        username: [{ validator: validPhone, trigger: "blur" }],
        password: [{ required: true, message: this.$t("login.pwd_empty"), trigger: "blur" }],
        verCode: [{ validator: validVerCode, trigger: "blur" }],
        phone: [{ validator: validPhone, trigger: "blur" }],
        regVerCode: [{ validator: validVerCode, trigger: "blur" }],
        project: [{ required: true, message: this.$t("login.project_required"), trigger: "blur" }],
        pwd: [{ validator: validValueNumAndLetter, trigger: "blur" }],
        rePwd: [{ validator: validSurePwd, trigger: "blur" }],
        rePwd2: [{ validator: validSurePwd2, trigger: "blur" }],
        code: [{ validator: validVerCode, trigger: "blur" }],
      };
    },
  },
  watch: {
    curLang() {
      // 等待新规则生效后只清理旧语言提示，保留输入和正常失焦、提交校验
      this.$nextTick(() => {
        ['form', 'regForm', 'forgetForm', 'codeForm'].forEach(ref => {
          const form = this.$refs[ref];
          if (form) form.clearValidate();
        });
      });
    },
  },
  created() {},
  mounted() {
    this.getVerCode();
    this.rememberPwd = localStorage.getItem('remember') === 'true';
    if (this.rememberPwd) {
      const saved = localStorage.getItem('loginAcc');
      try {
        const info = JSON.parse(CryptoJS.AES.decrypt(saved, 'hwang').toString(CryptoJS.enc.Utf8));
        this.form.username = info.username || '';
        this.form.password = info.password || '';
      } catch (error) {
        // 缓存损坏不影响手动登录
      }
    }
  },
  methods: {
    async getVerCode(silent = false) {
      this.codeID = "";
      this.codeURL = "";
      try {
        const res = await getCode(undefined, true);
        if (!res || res.code !== 200 || !res.data) {
          throw new Error("验证码获取失败");
        }
        this.codeID = res.data.captchaId;
        this.codeURL = res.data.captchaImage;
      } catch (error) {
        if (silent !== true) {
          this.$message.error(this.$t("login.vercode_fail"));
        }
      }
    },
    // 登录方法
    async doLogin() {
      if (this.loading) return;
      this.loading = true;
      let attempted = false;
      let succeeded = false;
      const snapshot = sessionSnapshot();
      try {
        const valid = await new Promise((resolve) => this.$refs.form.validate(resolve));
        if (!valid) return;
        const param = {
          phoneNum: this.form.username,
          userPwd: this.form.password,
          captchaId: this.codeID,
          captchaVal: this.form.verCode,
        };
        const remember = this.rememberPwd;
        attempted = true;
        const res = await login(param);
        if (this._isDestroyed || !isCurrentSession(snapshot)) return;
        if (!res || res.code !== 200) {
          // 403 同时用于冻结；兼容请求期间切换语言后的审核响应
          if (res && res.code === 403 && this.$i18n.availableLocales.some(lang => res.msg === this.$i18n.t("login.auditing_msg", lang))) {
            this.show = true;
          } else {
            this.$message.error((res && res.msg) || this.$t("login.login_fail"));
          }
          return;
        }
        if (!res.data || !res.data.token || !Array.isArray(res.data.permissions)) {
          this.$message.error(this.$t("login.login_resp_err"));
          return;
        }
        // 非目录路由暂时先前端写死
        const menuNav = [
          {
            id: 11,
            pid: "0",
            name: "基本信息",
            icon: "",
            path: "baseInfo",
            hidden: true,
          },
          {
            id: 12,
            pid: "0",
            name: "开发应用",
            icon: "",
            path: "developApp",
            hidden: true,
          },
          {
            id: 13,
            pid: "0",
            name: "开发文档",
            icon: "",
            path: "document",
            hidden: true,
          },
          {
            id: 14,
            pid: "13",
            name: "开发文档",
            icon: "",
            path: "document",
            hidden: false,
          },
          {
            id: 15,
            pid: "13",
            name: "简介",
            icon: "",
            path: "introduction",
            hidden: false,
          },
          {
            id: 16,
            pid: "13",
            name: "生成access Token",
            icon: "",
            path: "token",
            hidden: false,
          },
          {
            id: 17,
            pid: "13",
            name: "状态码",
            icon: "",
            path: "code",
            hidden: false,
          },
        ];
        const menus = res.data.permissions.concat(menuNav);
        const icons = ["icon-shebeiguanli", "icon-quanxianshenhe"];
        await this.$router.selfAddRoutes(
          menus.map((f, index) => ({
            ...f,
            icon: icons[index],
            route: f.path,
            pid: f.pid && f.pid == 0 ? "" : f.pid,
          }))
        );
        // selfAddRoutes 重建 matcher 会瞬时卸载本页，_isDestroyed 属误判；账号切换竞态由 isCurrentSession 兜底
        if (!isCurrentSession(snapshot)) return;
        advanceSession();
        // 仅成功后更新登录态及凭据，缓存绑定本次实际提交的账号
        localStorage.setItem("token", JSON.stringify(res.data.token));
        localStorage.setItem("userInfo", JSON.stringify(res.data));
        localStorage.setItem("remember", remember);
        if (remember) localStorage.setItem('loginAcc', CryptoJS.AES.encrypt(JSON.stringify({ username: param.phoneNum, password: param.userPwd }), 'hwang').toString());
        else localStorage.removeItem('loginAcc');
        // 后端 LoginOutput 字段为 roleIds（camelCase），role_ids 恒为 undefined 会把 roleFlag 覆盖成 undefined
        this.$store.commit("permission/SET_ROLE_FLAG", res.data.roleIds);
        this.$store.commit("SET_LOGIN_STATUS", true);
        setCookie("open_token", res.data.token);
        succeeded = true;
        afterLogin(res.data || {});
        this.$message.success(this.$t("login.login_success"));
        // 密码策略升级：存量用户首次登录后强制先设置新密码
        if (res.data.needResetPwd == 1) {
          localStorage.setItem("needResetPwd", "1");
          this.$router.push("/resetPwd");
        } else {
          localStorage.removeItem("needResetPwd");
          this.$router.push("/");
        }
      } catch (error) {
        if (this._isDestroyed || !isCurrentSession(snapshot)) return;
        const result = error.response && error.response.data;
        this.$message.error((result && (result.msg || result.message)) || this.$t("login.login_net_err"));
      } finally {
        if (attempted && !succeeded && !this._isDestroyed && isCurrentSession(snapshot)) {
          // 验证码可能已消费，仅刷新验证码，保留当前账号和密码
          this.form.verCode = "";
          await this.getVerCode(true);
        }
        this.loading = false;
      }
    },
    verPhone() {
      this.$refs.forgetForm.validate((valid) => {
        if (valid) {
          console.log("通过");
          this.checkPhone = false;
        }
      });
    },
    // 提交后重置表单
    resetPwdForm(){
      if(this.timer){
        clearInterval(this.timer)
        this.timer = null
      }
      this.getMsgCode = false
      this.second = 60
      this.forgetForm = {
        regVerCode: "",
        phone: "",
        pwd: "",
        rePwd2: "",
      }
    },
    // 忘记密码
    toSetPwd() {
      let param = {
        phone_num: this.forgetForm.phone,
        user_pwd: this.forgetForm.pwd,
        verify_code: this.forgetForm.regVerCode,
      };
      // console.log(param, "重置")
      this.$refs.forgetForm.validate((valid) => {
        if (valid) {
          console.log("通过");
          resetPwd(param).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.$t("login.reset_success"));
              this.checkPhone = true;
              this.login = "login";
              this.resetPwdForm()
            }
          });
        }
      });
    },
    // 获取短信验证码弹窗
    regGetCode(e) {
      this.$refs.regForm.validateField("phone", (valid) => {
        if (!valid) {
          // 校验通过
          this.getMsgType = e
          this.codeShow = true;
          this.getVerCode();
        }
      });
    },
    // 获取短信验证码弹窗
    forgetGetCode(e) {
      this.$refs.forgetForm.validateField("phone", (valid) => {
        if (!valid) {
          // 校验通过
          this.getMsgType = e
          this.codeShow = true;
          this.getVerCode();
        }
      });
    },
    // 获取短信验证码
    setTime() {
      this.$refs.codeForm.validate((valid) => {
        if (valid) {
          let param = {
            phoneNum: this.getMsgType == 'reg' ? this.regForm.phone : this.forgetForm.phone,
            captchaId: this.codeID,
            captchaVal: this.codeForm.code,
          };
          // console.log(param, "param")
          // return
          getMsgCode(param).then((res) => {
            if (res.code == 200) {
              this.codeShow = false;
              this.getMsgCode = true;
              this.timer = setInterval(() => {
                if (this.second <= 1) {
                  this.getMsgCode = false;
                  this.second = 60;
                  clearInterval(this.timer);
                  this.timer = null;
                } else {
                  this.second -= 1;
                }
              }, 1000);
              this.$message.success(this.$t("login.sms_success"));
              this.$refs.codeForm.resetFields();
            }
            this.getVerCode();
          });
        }
      });
    },
    loginChange(type) {
      this.regForm.phone = this.form.username;
      this.forgetForm.phone = this.form.username;
      if (type == "login") {
        this.$refs.regForm.resetFields();
      } else if (type == "register" || type == "forget") {
        // this.$refs.form.resetFields();
      }
      this.login = type;
    },
    forgetBack(){
      this.login = "login";
      let arr = ['regVerCode','phone','pwd','rePwd2']
      this.$refs.forgetForm.clearValidate(arr);
      this.forgetForm = {
        regVerCode: "",
        phone: "",
        pwd: "",
        rePwd2: "",
      }
      this.checkPhone = true
    },
    register() {
      // 注册
      this.$refs.regForm.validate((valid) => {
        if (valid) {
          let param = {
            phoneNum: this.regForm.phone,
            projectName: this.regForm.project,
            userPwd: this.regForm.pwd,
            verifyCode: this.regForm.regVerCode,
          };
          // console.log(param, "pppp")
          register(param).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.$t("login.register_success"));
              this.$refs.regForm.resetFields();
              this.login = "login";
            }
          });
        }
      });
    },
    // 密码是否可见
    handleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    handleClick(type) {
      this.activeInput = type;
      //   console.log("222");
    },
    handleChangeLang(l) {
      if (l.type !== this.curLang) setLocale(l.type);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  // background: linear-gradient(225deg, #3361e2 0%, #00015f 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("../../../src/assets/images/login/login.png");
  .verCode {
    width: 120px;
    height: 38px;
    // background-color: #000;
    margin-left: 10px;
    cursor: pointer;
  }
  .main {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    div {
      padding: 5px;
    }
    .content {
      font-weight: bold;
      font-size: 26px;
      color: #333333;
      line-height: 37px;
    }
  }
  .btns {
    display: flex;
    // align-items: center;
    justify-content: center;
  }
}

.login-lang {
  position: absolute;
  top: 24px;
  right: 74px;
  z-index: 10;
}
.lang-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #dce3ed;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.8);
  color: #606b7a;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  &:hover {
    color: #0077ff;
    border-color: #a9c9ef;
  }
  &:focus-visible {
    outline: 2px solid #0077ff;
    outline-offset: 2px;
  }
}
.lang-globe {
  flex: none;
  width: 16px;
  height: 16px;
}
.lang-current {
  max-width: 144px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lang-arrow {
  font-size: 10px;
  transition: transform 0.2s;
  &.expanded {
    transform: rotate(180deg);
  }
}
.login-lang-menu {
  min-width: 168px;
  max-height: 280px;
  overflow-y: auto;
  padding: 6px 0;
  border-radius: 8px;
}
.login-lang-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  font-size: 13px;
  white-space: nowrap;
  &.active {
    color: #0077ff;
    background-color: #f0f6ff;
    font-weight: 500;
  }
}
@media (max-width: 580px) {
  .login-lang {
    right: 24px;
  }
}
.lg {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .login_main {
    width: 432px;
    .blue_line {
      width: 432px;
      height: 4px;
      border-radius: 5px;
      background-color: #0077ff;
      margin: 16px 0;
    }
    .login_form {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      // height: 150px;
      margin: 20px 0;
      .el-input {
        margin: 10px 0;
      }
    }
    .reg_form {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      // height: 200px;
      margin: 20px 0;
      .el-input {
        margin: 10px 0;
      }
    }
    .check_pass {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
    }
  }
}
.login {
  position: absolute;
  top: 0px;
  right: 0px;
  height: calc(100vh);
  width: 580px;
  background-color: rgba(240, 244, 250, 0.9);
}
.ft1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.ft2 {
  font-size: 22px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.icon_style {
  margin-left: 5px;
  color: #0077ff;
}
::v-deep {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #999999;
  }
}
</style>
